module.exports = __webpack_public_path__ + "static/media/1.85bfe2b0.webp";